import React, {Fragment, Suspense} from 'react';
import { useForm, Controller } from "react-hook-form";
import Common from "../../Common/Common";
import CommonHeaderContent from '../../Common/CommonHeaderContent';
import ListTable from '../../Common/ListTable';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import Switch from "react-switch";
import requestApiService from '../../services/requestApi.service';
import { confirmBoxWithImage } from '../../Common/Appcommon';
import { workflowSearchOptions } from '../Campaigns/Constants';
import succesTickIcon from "../../assets/utils/images/successtick.png";

class WorkFlow extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            showLoader : false,
            listFields : [],
            formData : [],
            page:1,
            limit:50,
            searchFields : {"STATUS" : "All", "NAME" : ""},
        }
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        
        await this.loadWorkflowFormData();
        this.setState({
            showLoader : false,
        })
    };

    openNewWorkFlow = async () =>{
        window.location.href = "#/workflow/new";
    }

    initiateEditWorkflow = async (e, triggerId) => {
        window.location.href = "#/workflow/edit/"+triggerId;
    }

    loadWorkflowFormData = async () => {
        let {searchFields} = this.state;
        let params = {
            "ENTITY": "NEW_WORKFLOW_ENTITY",
            "OPERATION" : "GET_WORKFLOW",
            "SEARCH" : searchFields['STATUS'] + "#" + searchFields['NAME']
        }
        let res = await requestApiService.processServerRequest(params);
        if(res.issuccess){
            let workflows = res.data;
            let workflowForm = workflows[0];
            let listFields = workflows[1];
            this.setState({
                formData: workflowForm,
                listFields : listFields,
            })
        }
    }

    renderElements = (name,formData,field) => {
        if(name === 'pause_workflow'){
            return (
                <div>
                    <Switch height={15} width={30} onColor={"#23ae73"}  checked={formData['status'].toLowerCase() == 'active' ? true : false} onChange={(e) => {this.handleCheckboxChange(e,formData);}}/>
                </div>
            );
        } else if(name === 'statusBadge'){
            let fieldvalue = formData['formname'];
            let bclass = 'bg-info';
            return (
                <>
                    <div className={`ml-1 badge rounded-pill ${bclass}`}>
                        {fieldvalue}
                    </div>
                </>
            )
        }
    }

    handleCheckboxChange = async (e,formData) => {
        let isPaused = false;
        if(formData['status'].toLowerCase() === "active"){
            isPaused = await confirmBoxWithImage("Deactivate Workflow","Are you sure you want to deactivate this workflow?",'',"OK","Cancel","","",false,false,false);
        } else if (formData['status'].toLowerCase() === "inactive") {
            let imageIcon = succesTickIcon;
            isPaused = await confirmBoxWithImage("Activate Workflow","Are you sure you want to activate this workflow?",imageIcon,"OK","Cancel","","",false,false,false);
        }
        if(isPaused){
            let params = {
                "ENTITY": "NEW_WORKFLOW_ENTITY",
                "OPERATION" : 'Update_Status',
                "status" : formData['status'].toLowerCase() === "active" ? "InActive" : "Active",
                "triggerid" : formData['id']
            }
            let response = await requestApiService.processServerRequest(params);
            if(response.issuccess){
                await this.loadWorkflowFormData();
            }
        }
    }

    handleSearchChange = async(e) => {
        let {searchFields} = this.state;
        let filterValue = e.value;
        if(filterValue !== undefined){
            searchFields["STATUS"] = filterValue;
        } else {
            searchFields["NAME"] = e.target.value;
        }
        this.setState({ searchFields },async ()=>{
            await this.loadWorkflowFormData();
        });
    }

    render(){
        let {formData, listFields} = this.state;
        let customRowConfig = {
            link : {
                onClick : this.initiateEditWorkflow,
                condition : "",
                class : "row-link"
            }
        }
        let headerFieldConfig = {
            "Name" : {
                "class" : "text-left col-md-3"
            },
            "Actions" : {
                "class" : "w-5"
            },
            "Active/Inactive" : {
                
            }
        };
        let customFieldConfig = {
            'name' : {
                'class' : "text-left col-md-3"
            },
            'sys_count' : {
                'class' : 'w-5'
            },
            'status' : {
                "render": "pause_workflow",
                "disableLink" : true
            },
            formname : {
                "render" : "statusBadge"
            },
            last_modified : {
                toLocalDate : true
            },
            last_executed : {
                toLocalDate : true
            }
        };
        return (
            <Common pageTitle={"Workflows"} showLoader={this.state.showLoader}  customClass="no-padding" mainContent={
                <Fragment>
                    <CommonHeaderContent
                        isStatusFilter={true}
                        isSearchBox={true}
                        selectOptions={workflowSearchOptions}
                        searchChangeHandler={this.handleSearchChange}
                        searchChangeNameHandler={this.handleSearchChange}
                        buttonAction={this.openNewWorkFlow}
                        buttonIcon={faCirclePlus}
                        prefix={'automations'}
                        headerTitle={'Workflows'}
                        buttonTxt={'New Workflow'}
                        mainContent={
                            <div className={'main-card card mh-350'}>
                                <div className={'card-body p-tb-0'}>
                                    <ListTable
                                        key={Math.random()}
                                        formData={formData}
                                        fields={listFields}
                                        showRowCount={true}
                                        customRowConfig={customRowConfig}
                                        config={customFieldConfig}
                                        renderElements={this.renderElements}
                                        formName={this.formname}
                                        isDeleteNeeded={false}
                                        viewNeeded={false}
                                        showAccordian={false}
                                        prefix={'automations'}
                                        analyticsNeeded={false}
                                        isTableForm={false}
                                        accordianName={'automation-analytics'}
                                        customClass={'no-border-table'}
                                        headerConfig={headerFieldConfig}
                                    />
                                </div>

                            </div>

                        } />
                </Fragment>
            } />
        )
    }
}
export default WorkFlow;
